import { render } from "./BannerAdmin.vue?vue&type=template&id=48d17747"
import script from "./BannerAdmin.vue?vue&type=script&lang=js"
export * from "./BannerAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__